<template>
    <div>
        other Pageone
    </div>
</template>

<script>

export default {
    components:{
    }
}
</script>